import { GtmEvents } from '@/gtm/gtm-events';

export class CommonGtmEvents extends GtmEvents {
  eventCategory = 'СобытияОбщие';

  viewMainPage({ cityName }) {
    return this.gtmEvent({
      eventAction: 'Главная_ПросмотрСтраницы',
      eventLabel: cityName,
    });
  }

  viewSearchPage({ query }) {
    return this.gtmEvent({
      eventAction: 'СтраницаПоиска_ПросмотрСтраницы',
      eventLabel: query,
    });
  }

  addToFavorite({ productCode, productId, price, quantity }) {
    return this.gtmEvent({
      eventAction: 'Общее_ДобавитьВИзбранное',
      eventLabel: productCode,
      params: {
        mindbox: {
          sku: productId,
          price,
          quantity: quantity || 1,
        },
      },
    });
  }

  removeFromFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Общее_УдалитьИзИзбранного',
      eventLabel: productCode,
    });
  }

  toggleFavorite({ value, productCode, productId, price, quantity }) {
    return value
      ? this.addToFavorite({ productCode, productId, price, quantity })
      : this.removeFromFavorite({ productCode });
  }

  addToCart({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Общее_ДобавитьВКорзину',
      eventLabel: productCode,
    });
  }

  successSubscribe({ url, email }) {
    return this.gtmEvent({
      eventAction: 'Общее_УспешнаяПодписка',
      eventLabel: url,
      params: {
        data: {
          email,
        },
      },
    });
  }

  viewThanksPage({
    orderNumber,
    email,
    cartId,
    subtotal,
    deliveryAmount,
    products = [],
    coupons,
    accountId,
  }) {
    const coupon = products?.[0]?.discounts.find(d => d.type === 'promocode')?.name
      || coupons[0]
      || '';

    const productsData = products?.map(p => {
      const breadcrumbs = p.models?.[0]?.breadcrumbs || [];

      return {
        name: p.models?.[0]?.name,
        id: p.id,
        price: p.totalPrice,
        category: breadcrumbs[breadcrumbs.length - 1]?.name || '',
        variant: p.skuId,
        quantity: p.quantity,
        scId: p.id,
        dimension11: p.skuId,
      };
    });

    const params = {
      userParams: {
        email,
      },
      ecommerce: {
        purchase: {
          actionField: {
            affiliation: cartId,
            id: orderNumber,
            revenue: subtotal,
            shipping: deliveryAmount,
            coupon,
          },
          products: productsData,
        },
      },
      mindbox: {
        profileid: accountId,
      },
    };

    const gtmPromise = this.gtmEvent({
      eventAction: 'СпасибоЗаЗаказ_ПросмотрСтраницы',
      eventLabel: orderNumber,
      params,
    });

    const crtoPromise = this.crtoEvent('crto_transactionpage', {
      transactionid: orderNumber,
      products: products.map(({ id, totalPrice, quantity }) => ({
        id,
        quantity,
        price: totalPrice,
      })),
    });

    return Promise.allSettled([gtmPromise, crtoPromise]);
  }

  viewThanksPageAll({ orders, cartId, accountId }) {
    const promises = orders.map(({
        subtotal,
        deliveryAmount,
        contact,
        products,
        orderNumber,
        coupons,
      }) => this.viewThanksPage({
        cartId,
        email: contact.email,
        orderNumber,
        subtotal,
        deliveryAmount,
        products,
        coupons,
        accountId,
      }),
    );

    return Promise.allSettled(promises);
  }
}

export const commonGtmEvents = new CommonGtmEvents();
